// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";
import { SystemListApiParameter, SystemListModel } from "@tps/App/Services/SystemListService";
import { Draft } from "immer";

export type SystemListState = {
    isLoading: any;
    [key: string]: SystemListModel;
};

const initialSystemListState: SystemListState = {
    isLoading: false as any,
};

const xSystemList = createTypedReducerWithImmer(initialSystemListState, {
    "xSystemLists/isLoadingLoadSystemList": (draft: Draft<SystemListState>, action: { isLoading: boolean }) => {
        draft.isLoading = action.isLoading;
    },
    "xSystemLists/CompleteLoadSystemList": (
        draft: Draft<SystemListState>,
        action: { parameter: SystemListApiParameter; systemList: SystemListModel },
    ) => {
        draft[action?.parameter.name] = action.systemList!;
        draft.isLoading = initialSystemListState.isLoading;
    },
});

(reducers as any).xSystemList = xSystemList;

export type xSystemListstate = {
    xSystemList: SystemListState;
} & ApplicationState;

type xSystemListReducers = {
    systemList: typeof xSystemList;
};

export type xSystemListActions = Parameters<xSystemListReducers[keyof xSystemListReducers]>[1] | AnyAction;
